import { render } from "./KitchenOrderItemItem.vue?vue&type=template&id=25815286&scoped=true"
import script from "./KitchenOrderItemItem.vue?vue&type=script&lang=js"
export * from "./KitchenOrderItemItem.vue?vue&type=script&lang=js"

import "./KitchenOrderItemItem.vue?vue&type=style&index=0&id=25815286&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25815286"]])

export default __exports__
import QChip from 'quasar/src/components/chip/QChip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QChip,QIcon});
